import { render, staticRenderFns } from "./ProjectSoftwares.vue?vue&type=template&id=50b0beee&scoped=true"
import script from "./ProjectSoftwares.vue?vue&type=script&lang=js"
export * from "./ProjectSoftwares.vue?vue&type=script&lang=js"
import style0 from "./ProjectSoftwares.vue?vue&type=style&index=0&id=50b0beee&prod&scoped=true&lang=css"
import style1 from "./ProjectSoftwares.vue?vue&type=style&index=1&id=50b0beee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b0beee",
  null
  
)

export default component.exports